<template>
  <div class="fixed_page"  id="blurry">
    <div class="get-started">
    <div class="get-started-main">
      <div class="fixed_page">
        <div class="main_section_get_started">
          <div class="logo"><img :src="getTranslations.logo_for_get_started_branded_projects || getTranslations.logo_for_branded_projects || 'static/images/logo_main.svg'" alt=""></div>
          <div class="title"><h1>{{ getTranslations.visitor_train_brain }}</h1></div>
         <div v-if="freePlayBuutton" >
          <div class="main_buttons_get_started">
            <div class="two_btns">
              <a style="cursor:pointer" @click.prevent="playTrial()" class="ti_btn--main">{{ getTranslations.visitor_free_trial_play }}</a>
            </div>

          </div>
           </div>
        </div>
        <div class="get-started-main_carousel">
          <div class="col-md-12">
            <div class="tab-container__item active" id="daily">
              <carousel/>
            </div>
          </div>
        </div>
        <div class="circle_background">
          <div v-if="!freePlayBuutton" >
          <div class="main_buttons_get_started">
            <div class="two_btns">
              <a @click.prevent="goToRegistration" style="cursor: pointer" class="ti_btn--main">
                {{ getTranslations.visitor_visitor_header_register }}
              </a>
            </div>
            <div class="two_btns">
              <a>
                <router-link :to="'login'" class="ti_btn--second">
                  {{ getTranslations.visitor_visitor_header_login }}
                </router-link>
              </a>
            </div>
          </div>
            <div class="get_started_info_section">
              <div class="col-lg-12">
                <h1>{{ getTranslations.visitor_play_learn_more }} <span class="make_bold"> {{ getTranslations.visitor_win_more }}</span></h1>
                <p> {{ getTranslations.visitor_play_brain_games }}<span class="make_bold"> {{ getTranslations.home_grand_prize_draw }} </span>
                  {{ getTranslations.home_grand_prize_worth }} <span class="make_bold"> {{ getTranslations.visitor_grand_prize_value }}</span></p>
              </div>
            </div>
          </div>
          <div v-else>
            <div class="get_started_info_section for_free_play">

              <div class="col-lg-12">
                <h1>{{ getTranslations.visitor_play_learn_more }} <span class="make_bold"> {{ getTranslations.visitor_win_more }}</span></h1>
                <p> {{ getTranslations.visitor_play_brain_games }}<span class="make_bold"> {{ getTranslations.home_grand_prize_draw }} </span>
                  {{ getTranslations.home_grand_prize_worth }} <span class="make_bold"> {{ getTranslations.visitor_grand_prize_value }}</span></p>
              </div>
            </div>
          </div>

          <div class="col-md-12">
            <div class="get_started_list_section" v-if="!hideForExternalRedirectionProjects()">
              <div class="main_title"><h1> {{ getTranslations.vistitor_winners_winners_history }} </h1></div>

              <div class="filter">

                <a id="#weekly" v-if="hasValue(0)" class="weekly" @click="setFilter($event, 'weekly')">{{ getTranslations.visitor_winners_weekly }}</a>
                <a id="#monthly" v-if="hasValue(1)" class="monthly" @click="setFilter($event,'monthly')">{{ getTranslations.visitor_winners_monthly }}</a>
                <a id="#grand" v-if="hasValue(2)" class="grand" @click="setFilter($event,'grand')">{{ getTranslations.visitor_winners_grand }}</a>
                <a id="#all" v-if="hasValue(3)" class="all current" @click="setFilter($event,'all')">{{ getTranslations.visitor_winners_all }}</a>
              </div>
              <div class="filter_list">
                <visitor-winners v-show="getFilter === 'weekly'" :winners-list="instantWin"/>
                <visitor-winners v-show="getFilter === 'grand'" :winners-list="grandWin"/>
                <visitor-winners v-show="getFilter === 'monthly'" :winners-list="monthlyWin"/>
                <visitor-winners v-show="getFilter === 'all'" :winners-list="allWinners"/>

<!--                <div class="load_more_btn rank" v-if="moreWinnersIButton"> &lt;!&ndash; TODO FIX &ndash;&gt;-->
<!--                  <a href="#" class="load-more btn2 btn2&#45;&#45;std btn2&#45;&#45;small" @click="displayMore(3)">···</a>-->
<!--                </div>-->
              </div>
            </div>
          </div>
        </div>

    </div>
    </div>
      <div class="black-overlay"></div>
    <simplify-registration v-if="showSimpleRegistrationModal"
                                             @close="showSimpleRegistrationModal = false;">
    </simplify-registration>
      <cookies-pop-up v-if="showCookiesPopUp && cookiesPopUpEnabled"
                      @close="showCookiesPopUp = false;">
      </cookies-pop-up>
      <sub-verify-wifi v-if="HE_ERROR_CODE"
                       @close="HE_ERROR_CODE = false;">
      </sub-verify-wifi>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations, mapState } from 'vuex';
import Vue from 'vue';
import IntegrationMixin from '@/common/mixins/integration';
import RegistrationFlowMixin from '@/common/mixins/flow';
import simplifyRegistration from '@/components/home/modals/SimplifyRegistration';
import cookiesPopUp from '@/components/home/modals/CookiesPopUp';
import subVerifyWifi from '@/components/home/modals/SubscriptionVerifyWifi';
import VisitorWinners from './VisitorWinners';
import Carousel from '../../../../ui-src-brainiac/src/components/home/Carousel';

const moment = require('moment');

Vue.use(require('vue-moment'), {
  moment,
});

export default {
  name: 'index',
  mixins: [IntegrationMixin, RegistrationFlowMixin],
  components: {
    Carousel,
    VisitorWinners,
    cookiesPopUp,
    simplifyRegistration,
    subVerifyWifi,
  },
  props: ['freePlayBuutton'],
  data() {
    return {
      showSimpleRegistrationModal: false,
      countTestimonials: 0,
      showCookiesPopUp: true,
      showMoreGrand: false,
      showMoreMonthly: false,
      showMoreInstant: false,
      filter: 'all',
      winnersHistoryKeys: ['visitor_winners_weekly', 'visitor_winners_monthly', 'visitor_winners_grand', 'visitor_winners_all'],
    };
  },
  created() {
    if (localStorage.getItem('cookiesEnabled') === 'true') {
      this.showCookiesPopUp = false;
    }
  },
  methods: {
    ...mapActions('profile', [
      'storeVisitorWinners',
    ]),
    ...mapMutations('profile', [
      'setMoreWinnersButton',
    ]),
    setFilter(e, category) {
      this.filter = category;
      /* eslint-disable */
      console.log(e.target);
      $('.all').removeClass('current');
      $('.weekly').removeClass('current');
      $('.monthly').removeClass('current');
      $('.grand').removeClass('current');
      $(e.target).addClass('current');
    },
    hasValue(i) {
      return this.getTranslations[this.winnersHistoryKeys[i]] != null;
    },
    goToRegistration() {
      if (!this.hasWebRegister()) {
        this.showSimpleRegistrationModal = true;
      } else {
        this.registrationRedirect();
      }
    },
    playTrial() {
      this.$router.replace('trial/gameFreePlay');
    },
    hideForExternalRedirectionProjects(){
      return this.integrationHeader === this.availableIntegrations.ROSHAN_AFG.name;

    },
    displayMore(i) {
      if (i === 1) {
        if (this.moreWinnersButton) {
          this.showMoreGrand = !this.showMoreGrand;
        }
      }
      if (i === 2) {
        if (this.moreWinnersMButton) {
          this.showMoreMonthly = !this.showMoreMonthly;
        }
      }
      if (i === 3) {
        if (this.moreWinnersIButton) {
          this.showMoreInstant = !this.showMoreInstant;
        }
      }
    },
    normalizeDate(date) {
      moment.locale(localStorage.getItem('locale'));
      return moment(date).format('DD/MM/YYYY');
    },
  },
  computed: {
    getFilter() {
      return this.filter;
    },
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
    ...mapState('common', [
      'cookiesPopUpEnabled',
      'availableIntegrations',
    ]),
    ...mapState('profile', [
      'monthlyButton',
      'grandButton',
      'weeklyButton',
      'moreWinnersButton',
      'moreWinnersMButton',
      'moreWinnersIButton',
      'totalWinners',
      'grandWin',
      'monthlyWin',
      'allWinners',
      'instantWin', // weekly winners
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/visitor/Index.vue